import React, { useState } from "react";
import "./EnterInfo.css";

export default function EnterInfo({ addPeople }) {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [firstNameValid, setFirstNameValid] = useState(true);
  const [lastNameValid, setLastNameValid] = useState(true);
  const [phoneValid, setPhoneValid] = useState(true);
  const [phoneFormatValid, setPhoneFormatValid] = useState(true);

  const firstNameHandler = (e) => {
    e.preventDefault();
    setFirstName(e.target.value);
  };

  const lastNameHandler = (e) => {
    e.preventDefault();
    setLastName(e.target.value);
  };

  const phoneHandler = (e) => {
    e.preventDefault();
    setPhone(e.target.value);
  };

  const validation = () => {
    if (firstName === "" || lastName === "" || phone === "") {
      firstName === "" ? setFirstNameValid(false) : setFirstNameValid(true);
      lastName === "" ? setLastNameValid(false) : setLastNameValid(true);
      if (phone === "") {
        setPhoneValid(false);
      } else {
        setPhoneValid(true);
      }
      return;
    } else {
      return true;
    }
  };

  const phoneFormatValidator = (num) => {
    if (phone === "") return;

    // const format = /^\(?([0-9]{3})\)?[-]?([0-9]{3})[-]?([0-9]{4})$/;
    const format = /^\d{3}-\d{3}-\d{4}$/;
    if (num.match(format)) {
      setPhoneFormatValid(true);
      return true;
    } else {
      setPhoneFormatValid(false);
      return false;
    }
  };

  const addHandler = (e) => {
    const valid = validation();
    const formatValid = phoneFormatValidator(phone);
    if (valid && formatValid) {
      addPeople(firstName.trim(), lastName.trim(), phone);

      setFirstName("");
      setLastName("");
      setPhone("");

      setFirstNameValid(true);
      setLastNameValid(true);
      setPhoneValid(true);
    }
  };

  return (
    <div className="EnterInfo">
      <form>
        <div>
          <label htmlFor="firstName" className="form-label">
            First Name
          </label>
          <input
            type="text"
            id="firstName"
            className="form-control"
            aria-label="First Name"
            value={firstName}
            onChange={firstNameHandler}
          ></input>
          {!firstNameValid && (
            <p className="validationError">Please enter first name</p>
          )}
        </div>
        <div>
          <label htmlFor="lastName" className="form-label mt-3">
            Last Name
          </label>
          <input
            type="text"
            id="lastName"
            className="form-control"
            aria-label="Last Name"
            value={lastName}
            onChange={lastNameHandler}
          ></input>
          {!lastNameValid && (
            <p className="validationError">Please enter last name</p>
          )}
        </div>
        <div>
          <label htmlFor="phone" className="form-label mt-3">
            Phone (xxx-xxx-xxxx)
          </label>
          <input
            type="text"
            id="phone"
            className="form-control"
            aria-label="Phone number"
            value={phone}
            onChange={phoneHandler}
          ></input>
          {!phoneValid && (
            <p className="validationError">Please enter phone number</p>
          )}
          {!phoneFormatValid && (
            <p className="validationError">Phone number must be xxx-xxx-xxxx</p>
          )}
        </div>
        <button
          type="button"
          className="btn btn-dark mt-4 pt-3 pb-3 ps-4 pe-4"
          onClick={addHandler}
        >
          Add
        </button>
      </form>
    </div>
  );
}
